import { render } from "./ViewTraineeTable.vue?vue&type=template&id=05902fcb&scoped=true"
import script from "./ViewTraineeTable.vue?vue&type=script&lang=js"
export * from "./ViewTraineeTable.vue?vue&type=script&lang=js"

import "./ViewTraineeTable.vue?vue&type=style&index=0&id=05902fcb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05902fcb"]])

export default __exports__